import { MpModalController } from '../../../core/overlay/mp-modal.controller';
import { OverlayHandle } from '../../../core/overlay/overlay.service';
import { MultipedidosCreditDialogComponent } from './multipedidos-credit-dialog.component';

export interface JanelaMultipedidos {
	/** O onboarding com os UTMs de quem abriu a janela — o `href` do elemento tocado. */
	href: string;
	/** "Quero um cardápio digital e muito mais": chamado no próprio toque, antes de a outra aba abrir. */
	aoQuerer: (msDesdeAberta: number) => void;
	/** A janela fechou sem ir ao onboarding. `fechouPor`: `voltar` | `backdrop` | `back` | `destroy`. */
	aoFechar: (fechouPor: string, msDesdeAberta: number) => void;
}

/**
 * Abre a janela sobre a Multipedidos — a do crédito "Desenvolvido com ❤️ pela
 * Multipedidos" e a do banner do fim do cardápio — e avisa o que a pessoa fez
 * nela. Toda janela aberta termina em exatamente um aviso: `aoQuerer` ou
 * `aoFechar`.
 *
 * Import estático da janela, e não `import()`: o toque já cancelou o link, e
 * um chunk que não carregasse (webview do Instagram, 3G, aba com a build
 * anterior ao deploy) deixaria o toque sem efeito nenhum.
 *
 * O voltar do navegador fecha a janela em vez de sair da tela de baixo.
 */
export async function abrirJanelaMultipedidos(modalCtrl: MpModalController, janela: JanelaMultipedidos): Promise<OverlayHandle> {
	const abertaEm = performance.now();
	const msDesdeAberta = () => Math.round(performance.now() - abertaEm);
	const handle = await modalCtrl.create({
		component: MultipedidosCreditDialogComponent,
		componentProps: {
			href: janela.href,
			aoQuerer: () => janela.aoQuerer(msDesdeAberta()),
		},
		cssClass: 'modal-mpCredit-dialog',
		interceptHistoryBack: true,
	});
	handle.onDidDismiss().then(({ role }) => {
		if (role === 'cta') return; // avisado no próprio toque
		janela.aoFechar(role || 'outro', msDesdeAberta());
	});
	await handle.present();
	return handle;
}
